module.exports = __webpack_public_path__ + "img/sx.563169bc.png";